import React from 'react';

import Layout from '../components/Layout';
import Bills from '../components/Home/Bills';
import Header from '../components/Home/Header';
import Market from '../components/Home/Market';
import Overview from '../components/Home/Overview';

export default function Lend() {
  return (
    <Layout>
      <div className="w-full flex flex-col items-center justify-center space-y-20">
        <Header />
        <Overview />
        <Bills />
        <Market />
      </div>
    </Layout>
  );
}
